<style>
@import '../../custom/css/cotacao.css';
.aprovarPedido {
  float: right;
  color: rgb(233, 10, 10);
}
</style>

<template>
  <div id="cotacao-aprovada" class="cotacao" v-if="!checkIsEmpty(cotacao)">
    <div class="row m-0">
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">
          Aguardando a confirmação do pagamento
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
                alt="Ícone para representar a cotação"
              />
            </div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Data:
                <div class="cc-sub-result">{{ cotacao[0].atualizado_em }}</div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Cód:
                <div class="cc-sub-result">{{ cotacao[0].cot_cotacao_id }}</div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Preferência:
                <div class="cc-sub-result">
                  {{ cotacao[0].cot_preferencia }}
                </div>
              </div>
            </div>
            <div class="cc-sub-line"></div>
            <div class="cc-sub-title d-flex align-items-center">
              <div>
                Respondidos:
                <div class="cc-sub-result">
                  {{ quantProdutoRespondidos }} de {{ totalProdutos }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0" v-if="cotacao[0].produtos !== null">
            <div class="table-responsive">
              <h5 class="text-indent-5px">Inserido por você!</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Rejeitado</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in cotacao[0].produtos"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.marca_nome">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem Marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.tipo_medida_nome">
                        {{ produto.tipo_medida_nome }}
                      </div>
                      <div v-else>Sem Medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.rejeitar == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td class="td">
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="cc-content p-0"
            v-if="cotacao[0].produtosImagemArquivo !== null"
          >
            <div class="table-responsive">
              <h5 class="text-indent-5px">Produtos do arquivo</h5>
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Medida</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Rejeitado</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in cotacao[0].produtosImagemArquivo"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.marca_nome">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem Marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.medida_nome">
                        {{ produto.medida_nome }}
                      </div>
                      <div v-else>Sem Medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.disponivel == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' +
                        [
                          produto.disponivel == true &&
                          produto.disponivel == 1 &&
                          produto.rejeitar !== true &&
                          produto.rejeitar !== 1
                            ? ''
                            : ' red-font',
                        ]
                      "
                    >
                      <div v-if="produto.rejeitar == true">Sim</div>
                      <div v-else>Não</div>
                    </td>
                    <td class="td">
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="cc-content p-0">
            <!-- Campo de arquivo -->
            <div class="row m-0" v-if="cotacao[0].arquivo !== null">
              <div class="col-12 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_arquivo !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_arquivo }}
                </div>
                <div
                  class="d-inline-block m-l-20px"
                  v-if="cotacao[0].arquivo !== null"
                >
                  <a
                    :href="`${getImagesAddress}` + cotacao[0].arquivo"
                    class="btn btn-primary c-pointer fs-14 text-uppercase bg-dark-blue"
                    download
                  >
                    Baixar arquivo
                    <i class="fas fa-file-upload m-l-7px"></i>
                  </a>
                </div>
              </div>
            </div>
            <!-- Campo de imagem -->
            <div class="row m-0" v-if="cotacao[0].imagem !== null">
              <div class="col-12 m-15px-0px">
                <div
                  class="d-inline-block"
                  v-if="cotacao[0].quantidade_foto !== null"
                >
                  Quantidade: {{ cotacao[0].quantidade_foto }}
                </div>
                <DownloadImages :allImages="this.cotacao[0].imagem" />
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="row m-0">
              <div class="col-3 p-0" v-if="!checkIsEmpty(cotacao[0].cot_cep)">
                <b class="font-weight-bold text-uppercase fs-14">CEP de entrega:
                </b>{{ cotacao[0].cot_cep }}
              </div>
              <div class="col-5 p-0" v-else>
                <b class="font-weight-bold text-uppercase fs-14">Forma de entrega: </b>
                <span>Retirar na loja</span>
              </div>
              <div class="col-2" v-if="!checkIsEmpty(cotacao[0].cot_cep)">
                <b class="font-weight-bold text-uppercase fs-14">Frete:</b>
                {{ cotacao[0].cot_frete }}
              </div>
              <div class="col-4 p-0 text-right">
                <div class="prazo-entrega text-right">
                  <b class="font-weight-bold text-uppercase fs-14">Meio de pagamento:</b>
                  {{ cotacao[0].pagamento_realizado }}
                </div>
              </div>
              <div class="col-3 p-0 text-right">
                <div class="prazo-entrega text-right">
                  <b class="font-weight-bold text-uppercase fs-14">Valor Total:</b>
                  {{ cotacao[0].cot_valor_total }}
                </div>
              </div>
            </div>
          </div>
          <div class="cc-footer">
            <div class="position-relative row m-0 p-10 linha-abaixo-cinza">
              <div class="col-2 p-0">
                <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="comentarios" ref="comentarios" title="Comentarios" hide-footer>
      <template slot="modal-title">Dúvidas sobre esse produto</template>
      <div class="d-block text-center">
        <div class="limit_comentarios">
          <div
            class="comentarios_mensagens"
            v-for="(mensagem, index) in mensagensCotacao"
            :key="index"
          >
            <div
              class="row m-0"
              v-if="mensagem.usuario_enviador_id !== dadosUsuario.id"
            >
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
              <div class="mensagem col-9 p-0 text-left fs-14">
                {{ mensagem.mensagem }}
              </div>
            </div>
            <div class="row m-0" v-else>
              <div class="mensagem col-9 p-0 text-right fs-14">
                {{ mensagem.mensagem }}
              </div>
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
            </div>
          </div>
        </div>
        <div class="caixa_texto_mensagem">
          <div class="row m-0">
            <div class="col-9 p-j-right-10px">
              <textarea
                class="caixa_texto fs-12"
                placeholder="Digite sua dúvida e clique em anexar!"
                v-model="mensagem"
              ></textarea>
            </div>
            <div class="col-3 p-j-left-10px">
              <div
                class="btn btn-envio-mensagem"
                @click="
                  enviarMensagemProd(
                    dadosUsuario.id,
                    cotacao[0].id,
                    cotacao[0].cot_usuario_respondeu_id
                  )
                "
              >
                Anexar
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('comentarios')"
        >Fechar</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DownloadImages from '../../components/DownloadImages.vue';
import ShopkeeperCotationInformation from '../../components/Shopkeeper/ShopkeeperCotationInformation.vue';

export default {
  name: 'cotacao-aprovada',
  components: {
    DownloadImages,
    ShopkeeperCotationInformation,
  },
  data: () => ({
    items: [],
    errors: [],
    mensagem: null,
    mensagemProdId: null,
    faturas: [],
    token: 'Token'
  }),
  props: ['id'],
  created() {
    const self = this;

    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }

    this.$store.dispatch('emptyCotacao').then(() => {
      this.$store.dispatch('startLoader');
      setTimeout(() => {
        self.$store
          .dispatch('showCotacaoRespondida', this.id)
          .then(() => {
            setTimeout(() => {
              self.$store.dispatch('endLoader');
            }, 1000);
          })
          .catch(() => {
            setTimeout(() => {
              self.$store
                .dispatch('showCotacaoRespondida', this.id)
                .then(() => {
                  setTimeout(() => {
                    self.$store.dispatch('endLoader');
                  }, 1000);
                })
                .catch(() => {
                  self.$store.dispatch('endLoader');
                  self.aviso(
                    'Não foi possível carregar os Orçamento! Tente novamente em 5 minutos!',
                    'danger'
                  );
                });
            }, 1000);
          });
      }, 1000);
    });
  },
  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      mensagensCotacao: (state) => state.mensagensCotacao,
      totalProdutos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;
          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              quantProdutos += state.cotacao[0].produtos.length;
            }
          }

          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              quantProdutos += state.cotacao[0].produtosImagemArquivo.length;
            }
          }

          return quantProdutos;
        }
      },
      quantProdutoRespondidos(state) {
        if (state.cotacao.length > 0) {
          let quantProdutos = 0;

          if (!this.checkIsEmpty(state.cotacao[0].produtos)) {
            if (state.cotacao[0].produtos.length > 0) {
              for (const produto in state.cotacao[0].produtos) {
                if (
                  (state.cotacao[0].produtos[produto].disponivel === 1 ||
                    state.cotacao[0].produtos[produto].disponivel === true) &&
                  (state.cotacao[0].produtos[produto].rejeitar === 0 ||
                    state.cotacao[0].produtos[produto].rejeitar === false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }

          if (!this.checkIsEmpty(state.cotacao[0].produtosImagemArquivo)) {
            if (state.cotacao[0].produtosImagemArquivo.length > 0) {
              for (const produto in state.cotacao[0].produtosImagemArquivo) {
                if (
                  (state.cotacao[0].produtosImagemArquivo[produto]
                    .disponivel === 1 ||
                    state.cotacao[0].produtosImagemArquivo[produto]
                      .disponivel === true) &&
                  (state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                    0 ||
                    state.cotacao[0].produtosImagemArquivo[produto].rejeitar ===
                      false)
                ) {
                  quantProdutos++;
                }
              }
            }
          }

          return quantProdutos;
        }
      },
    }),
  },
  mounted() {
    this.loadCheckout();
  },
  methods: {
  loadCheckout() {
    setTimeout(() => {
      this.$store
        .dispatch('showCheckout', this.cotacao[0].cot_cotacao_id)
        .then((resp) => {
          const response = resp.data;
          this.faturas = response;
          console.log(response);
        }).catch((err) => console.log(err));
    }, 2000)
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    finalizarCotacao() {
      if (confirm('Deseja finalizar essa cotação?')) {
        const values = {
          id: this.cotacao[0].id,
          idCotacao: this.cotacao[0].cot_cotacao_id,
        };

        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('updateCotacaoFinalizacao', values)
          .then((data) => {
            setTimeout(() => {
              this.$store.dispatch('endLoader');
              this.aviso('Sua cotação foi finalizada com sucesso!', 'success');
              setTimeout(() => {
                this.$router.push({ name: 'profissional-meus-dados' });
              }, 1000);
            }, 1500);
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.aviso(
              'Não foi possível finalizar a cotação! Tente novamente em 5 minutos.',
              'danger'
            );
          });
      }
    },
    voltarCotacao() {
      this.$router.push({
        name: 'profissional-aguardando-pagamento',
      });
    },
    verMensagens(UsuarioEnviador, produtoId, UsuarioRecebedor) {
      this.mensagemProdId = produtoId;
      this.$store
        .dispatch('showMensagensCotacaoResposta', produtoId)
        .then(() => {
          this.$bvModal.show('comentarios');
        });
    },
    enviarMensagemProd(UsuarioEnviador, cotacaoId, UsuarioRecebedor) {
      const self = this;
      const data = {
        usuario_enviador_id: UsuarioEnviador,
        cotacao_resposta_id: cotacaoId,
        cotacao_produto_id: this.mensagemProdId,
        usuario_recebedor_id: UsuarioRecebedor,
        mensagem: this.mensagem,
      };
      this.$store.dispatch('insertMensagem', data).then(() => {
        setTimeout(() => {
          if (this.getTipoNotification == 1) {
            this.aviso('Sua dúvida foi anexada com sucesso!', 'success');
            setTimeout(() => {
              this.$router.push({ name: 'profissional-finalizadas' });
            }, 1500);
          } else if (this.getTipoNotification == 3) {
            this.aviso(this.getNotification, 'danger');
          }
          this.$store.dispatch(
            'showMensagensCotacaoResposta',
            self.mensagemProdId
          );
          this.mensagem = null;
        }, 1000);
      });
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
